module.exports = __webpack_public_path__ + "media/images/qr/dots-494821d3507613750c753a64dfb3fc69.png";